"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowActionFileDownloadedEventDataSchema = exports.workflowActionCancelledEventDataSchema = exports.workflowActionFailedEventDataSchema = exports.workflowActionFileTransferFailedEventDataSchema = exports.projectItemDeletedEventDataSchema = void 0;
const zod_1 = require("zod");
const selectedItemWithName_schema_1 = require("./selectedItemWithName.schema");
const WorkflowActionType_1 = require("../project/WorkflowActionType");
exports.projectItemDeletedEventDataSchema = zod_1.z.object({});
exports.workflowActionFileTransferFailedEventDataSchema = zod_1.z
    .object({
    workflowActionId: zod_1.z.string(),
    workflowActionFileName: zod_1.z.string(),
    workflowActionType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(WorkflowActionType_1.WorkflowActionType),
})
    .strict();
exports.workflowActionFailedEventDataSchema = zod_1.z
    .object({
    workflowActionId: zod_1.z.string(),
    workflowActionType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(WorkflowActionType_1.WorkflowActionType),
})
    .strict();
exports.workflowActionCancelledEventDataSchema = zod_1.z
    .object({
    workflowActionId: zod_1.z.string(),
    workflowActionType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(WorkflowActionType_1.WorkflowActionType),
})
    .strict();
exports.workflowActionFileDownloadedEventDataSchema = zod_1.z
    .object({
    workflowActionId: zod_1.z.string(),
    workflowActionFileId: zod_1.z.string(),
    workflowActionFileName: zod_1.z.string(),
})
    .strict();
//# sourceMappingURL=eventData.schema.js.map